import { formatDistance } from "date-fns";
import { Tooltip } from "@chakra-ui/react";
import React from "react";

type DateDisplayProps = { date: Date; baseDate?: Date };

export function DateDisplay({ date, baseDate = new Date() }: DateDisplayProps) {
  const distance = getDistance(date, baseDate) + " ago";
  if (!distance) return <>{date.toLocaleString()}</>;
  return (
    <Tooltip label={distance}>
      <span>{date.toLocaleString()}</span>
    </Tooltip>
  );
}

function getDistance(date: Date, baseDate: Date) {
  try {
    return formatDistance(date, baseDate);
  } catch {
    console.error(`failed to format...`);
    return undefined;
  }
}
